export default (el) => {
  const $inner = $(el).find('.code-embed-block-inner[data-has-height="true"]').first();

  if (!$inner.length || $inner.attr('data-overflow-init') === '1') {
    return;
  }

  $inner.attr('data-overflow-init', '1');
  const inner = $inner[0];

  const update = () => {
    const hasOverflowY = inner.scrollHeight > inner.clientHeight + 1;
    const hasOverflowX = inner.scrollWidth > inner.clientWidth + 1;
    const hasOverflow = hasOverflowX || hasOverflowY;

    if (hasOverflow) {
      $inner.attr('data-has-overflow', 'true');
      return;
    }

    $inner.removeAttr('data-has-overflow');
  };

  update();
  window.setTimeout(update, 0);

  if (typeof ResizeObserver !== 'undefined') {
    const resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(inner);
  } else {
    $(window).on('resize', update);
  }

  const mutationObserver = new MutationObserver(update);
  mutationObserver.observe(inner, {
    childList: true,
    subtree: true,
    characterData: true
  });

  $inner.find('iframe').on('load', update);
};
